

































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class GiziSeksiChecklist extends Vue {
  @Prop({ required: true }) seksiKey!: string;
  @Prop({ required: true }) seksiLabel!: string;
  @Prop({ required: true }) items!: any[];
  @Prop({ default: false }) readonly!: boolean;

  subKategoriLabel(key: string) {
    const labels: Record<string, string> = {
      tempat_pengolahan: "Tempat Pengolahan",
      tenaga_pengolah: "Tenaga Pengolah",
      proses_pengolahan: "Proses Pengolahan",
    };
    return labels[key] || key;
  }

  get groupedItems() {
    const hasSub = this.items.some((i: any) => i.sub_kategori);
    if (!hasSub) {
      return [{ sub_kategori: null, items: this.items }];
    }

    const groups: any[] = [];
    const subMap: Record<string, any[]> = {};
    for (const item of this.items) {
      const sub = item.sub_kategori || "_none";
      if (!subMap[sub]) {
        subMap[sub] = [];
        groups.push({ sub_kategori: item.sub_kategori, items: subMap[sub] });
      }
      subMap[sub].push(item);
    }
    return groups;
  }

  isOutOfRange(item: any) {
    if (item.tipe_jawaban !== "numeric_range" || item.nilai_numeric == null) return false;
    const min = item.nilai_target_min;
    const max = item.nilai_target_max;
    if (min != null && item.nilai_numeric < min) return true;
    if (max != null && item.nilai_numeric > max) return true;
    return false;
  }

  emitChange() {
    this.$emit("change", this.items);
  }
}
